import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { activeSgbuildexElement, deactiveSgbuildexElement, deleteExtraction, fetchApsDownloadSV, fetchApsExtractionDetail, fetchApsExtractionList, fetchETSUpload, fetchTokenRefreshPBI, refreshPBI, updateExtraction, updateParameterPBI } from "../services/extractionServices";

export const useExtractionList = ({offset = 0, length = 100, type = ""}) =>{
  return useQuery({
    queryKey: ["extraction", { offset, length, type }],
    queryFn: () => fetchApsExtractionList({ offset, length, type }),
    staleTime: 5 * 60 * 1000
  });
}

export const useExtractionDetail = ({table, offset = 0, length = 100}) =>{
    return useQuery({
        queryKey: ["extractionDetail", {table, offset, length}],
        queryFn: () => fetchApsExtractionDetail({table, offset, length}),
        enabled: !!table,
        staleTime: 5 * 60 * 1000, // 5 min
    });
}



export const useUpdateExtraction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateExtraction,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extractionDetail'] });
    }
  });
};

export const useGetTokenRefreshPBI = () =>{
  return useQuery({
      queryKey: ["token-refresh-pbi"],
      queryFn: () => fetchTokenRefreshPBI(),
      staleTime: 5 * 60 * 1000, // 5 min
  });
}

export const useUpdateParameterPowerBI = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateParameterPBI,

    // refresh connection list
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: ['extraction'] });
    }
  });
};

export const useRefreshPowerBI = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshPBI,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extraction'] });
    }
  });
};

export const useDeleteExtraction = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: deleteExtraction,
  
      // refresh connection list
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['extraction'] });
      }
    });
};

// EXTRACT EXCEL ETS
export const useExtractETSFile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => {
      return fetchETSUpload(payload);
    },
    onSuccess: () => {
      // refresh extracttion list
      queryClient.invalidateQueries({ queryKey: ['extraction'] });
    }
  });
};

export const useApsDownloadFileCSV= (id) => {
  return useQuery({
    queryKey: ["download-csv", id],
    queryFn: () => fetchApsDownloadSV(id),
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

export const useActiveSgbuildexElement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activeSgbuildexElement,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};

export const useDeactiveSgbuildexElement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deactiveSgbuildexElement,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};

